import { render, staticRenderFns } from "./DatastoreEditor.vue?vue&type=template&id=265cf1ef"
import script from "./DatastoreEditor.vue?vue&type=script&lang=js"
export * from "./DatastoreEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports